import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 11 6"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M.642 4.914a.52.52 0 0 1 .157-.381L5.152.18A.49.49 0 0 1 5.534 0q.224 0 .381.18l4.353 4.353a.52.52 0 0 1 .157.381.52.52 0 0 1-.157.381l-.494.494a.56.56 0 0 1-.381.168.48.48 0 0 1-.382-.145L5.534 2.334 2.056 5.812a.48.48 0 0 1-.382.145.56.56 0 0 1-.381-.168l-.494-.494a.52.52 0 0 1-.157-.381"
    }, null, -1)
  ]))]))
}
export default { render: render }